import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9v12","key":"svg-0"}],["path",{"d":"M8 17l4 4l4 -4","key":"svg-1"}],["path",{"d":"M21 12a9 9 0 0 0 -18 0","key":"svg-2"}]]

/**
 * IconArrowUpFromArc
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtZnJvbS1hcmMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDl2MTIiIC8+CiAgPHBhdGggZD0iTTggMTdsNCA0bDQgLTQiIC8+CiAgPHBhdGggZD0iTTIxIDEyYTkgOSAwIDAgMCAtMTggMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-up-from-arc
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpFromArc = createReactComponent('outline', 'arrow-up-from-arc', 'ArrowUpFromArc', __iconNode);

export default IconArrowUpFromArc;